import type { Destination } from '@elara/client-core/models/DestinationModel';

import type { BaseDetailCardLayoutProps, CardLayout } from './DetailCardLayout.js';

import { getEmojiFlag } from '@elara/client-core/lib/utils';

import { CardDescription, DetailCardLayout } from './DetailCardLayout.js';

export interface DestinationCardProps extends BaseDetailCardLayoutProps {
  destination: Destination;
  /** Labelled actions rendered as a row below the content (`lg` only) — see `DetailCardLayout`. */
  footerActions?: React.ReactNode;
  /** `'row'` lays the card out photo-left for a hover popover — see `DetailCardLayout`. */
  layout?: CardLayout;
}

export function DestinationCard({
  destination,
  size = 'default',
  className,
  actions,
  footerActions,
  layout,
  href,
  onClick,
}: DestinationCardProps) {
  const displayTitle = destination?.displayName;
  const description = destination?.longDescription;
  const countryName = destination.location?.countryName;
  const countryCode = destination.location?.countryCode;

  const countryLine = (
    <span className="flex min-w-0 items-baseline gap-1 text-xs text-muted-foreground">
      {countryCode && <span>{getEmojiFlag(countryCode)}</span>}
      <span className="truncate">{countryName}</span>
    </span>
  );

  return (
    <DetailCardLayout
      images={destination?.imagesForGallery}
      title={displayTitle}
      type="destination"
      size={size}
      actions={actions}
      footerActions={footerActions}
      layout={layout}
      className={className}
      href={href}
      onClick={onClick}
    >
      {/* Under the title at every size, as one of the card's facts rather than an extension of the
          name. */}
      {countryName && <div className="flex flex-wrap items-center gap-x-3 gap-y-1">{countryLine}</div>}

      <CardDescription size={size}>{description}</CardDescription>
    </DetailCardLayout>
  );
}
